jQuery(function($){

	// fetch all ajax links
	$(document).on("click", ".ajax-link", function(e){
		// init
		e.preventDefault();
		var $link = $(this);

		// set loading
		$link.width($link.width());
		$link.height($link.height());
		$link.text("...").addClass("reloading");


		// fetch with ajax
		$.get($link.attr("href"), function(newElement){
			$link.replaceWith(newElement);
		});
	});
});